import { UserRole } from '@/types/auth'

const ROLE_LABELS: Record<string, string> = {
  [UserRole.DSTORRES]: 'DS Torres',
  [UserRole.OWNER]: 'Dono',
  [UserRole.SUPERADMIN]: 'Super Admin',
  [UserRole.ADMIN]: 'Administrador',
  [UserRole.USER]: 'Usuário',
}

/** Label PT-BR pra uma role — fallback pro valor cru se desconhecida. */
export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role
}

/** Nível na hierarquia — espelho de `python-orchestrator app/permissions/roles.py::_ROLE_LEVELS`.
 *  É por ele que coluna de cargo ORDENA: pelo rótulo, "Administrador" vinha antes de "Dono".
 *  Desconhecido fica abaixo de todos (0), nunca no meio. */
const NIVEL: Record<string, number> = {
  [UserRole.DSTORRES]: 999,
  [UserRole.OWNER]: 100,
  [UserRole.SUPERADMIN]: 80,
  [UserRole.ADMIN]: 50,
  [UserRole.USER]: 10,
}

export function nivelDoCargo(role: string): number {
  return NIVEL[role] ?? 0
}
